export default __webpack_public_path__ + "static/media/CNo.82-2.e7d64bca.jpg";